const doc = [({"no":({"js":({"notification":({"couldnt_submit_because_of_validation_errors":"Kunne ikke sende på grunn av valideringsfeil."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;